import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormEventHandlers from '../../../../../libs/utility/formeventhandlers/FormEventHandlers';
import { HEADING } from '../../../../components/heading/constants/constants';
import Heading from '../../../../components/heading/Heading';
import StepperNavigation from '../../../../components/steppernavigation/StepperNavigation';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { CREATE_FORMS_LOADING_STATES, CREATE_FORM_STATES_MESSAGE_MAP, FORM_STEP } from '../constants';
import { getFormData, getPayerList, getRecipient, getRecipientList, onDependentFieldChangeGetValues, saveForm } from '../CreateFormSaga';
import { componentKey, setIsIRSViewOn, setOnDependentFields, setReloadFormsPreLoadedData, setShouldLoadNextFormInSeries, setTempFormFieldsList, setToCreateFormData, updateFormsPreLoadedData, setElementToBeFocused, setStepperRefreshStep, setShowHelpPopup, setHelpTextObj } from '../CreateFormSlice';
import BasicInformation from './basicinformation/BasicInformation';
import styles from './CreateFormStepper.styles';
import createFormStyles from "../CreateForm.styles";
import FederalInformation from './federalinformation/FederalInformation';
import SelectPayer from './selectpayer/SelectPayer';
import SelectRecipient from './selectrecipient/SelectRecipient';
import StateInformation from './stateinformation/StateInformation';
import { componentKey as formsSectionComponentKey } from '../../FormsSectionSlice';
import Switch from '../../../../components/switch/Switch';
import { Theme } from '../../../../components/constants';
import IrsFormView from './irsformview/IrsFormView';
import OptionalInformation from './optionalinformation/OptionalInformation';
import { EDIT_FORM_ORIGIN, FORM_SECTION_ROUTES } from '../../constants';
import OtherInformation from './otherinformation/OtherInformation';
import Forms from '../../../../../libs/utility/formsutility/Forms';
import Loadable from '../../../../components/loadable/Loadable';
import RenderInteractionElement from './components/RenderInteractionElement';
import { CHANGE_PAYER_LABEL_IN_FORMS, IMPORTANT_FIELD_NAMES } from '../../formslisting/constants';
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook';
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook';
import Popup from '../../../../components/popup/Popup';

export default function CreateFormStepper() {

    const { loadingState, recipientListLoadingState, toCreateFormData, tempFormFieldsList, formFieldsList, isIRSViewOn, formsPreLoadedData, onDependentFields, userInteractionPopupWResponseObj, reloadFormsPreLoadedData, isStepperViewAvailable, isIRSViewAvailable, shouldLoadNextFormInSeries, formDataFromRecordId, formsInSeriesHistory, initialInteractionPopupWObj, elementToBeFocused, stepperRefreshStep, showHelpPopup, helpTextObj } = useSelector((state) => state[componentKey]);
    const { saveSingleFormSuccessData } = useSelector(state => state[formsSectionComponentKey]);
    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const [categoryCounts, setCategoryCounts] = useState({});
    const [createFormSteps, setCreateFormSteps] = useState([]);
    const [initSelectedPayerRenderDone, setInitSelectedPayerRenderDone] = useState(false);
    const [initSelectedRecipientRenderDone, setInitSelectedRecipientRenderDone] = useState(false);
    const [queryParams, setQueryParams] = useTxSearchParams()
    
	useEffect(() => {
		if(elementToBeFocused) {
            const element = document.getElementsByName(elementToBeFocused)[0];
            if(element){
                document.getElementsByName(elementToBeFocused)[0].focus()
            }
            dispatch(setElementToBeFocused(null))
		}
	},[elementToBeFocused])

    useEffect(() => {
        if(!isStepperViewAvailable && isIRSViewAvailable){
            dispatch(setIsIRSViewOn(true));
        }
    }, [isStepperViewAvailable, isIRSViewAvailable]);

    useEffect(() => {
        const formSteps = [
            {
                title: `Select ${CHANGE_PAYER_LABEL_IN_FORMS[toCreateFormData?.selectedForm?.FormId] ?? "Payer"}`,
                stepBodyComponent: <SelectPayer />,
                submitButtonText: "Next",
                submitButtonDisabled: toCreateFormData?.selectedPayer?.PayerDetailId ? false : true,
                submitButtonDisabledInfoCb: () => {
                    dispatch(addNotifications({ heading: `${CHANGE_PAYER_LABEL_IN_FORMS[toCreateFormData?.selectedForm?.FormId] ?? "Payer"} cannot be empty`, message: `To continue, please select a ${CHANGE_PAYER_LABEL_IN_FORMS[toCreateFormData?.selectedForm?.FormId] ?? "Payer"}` }))
                },
                submitCb: () => { dispatch(setStepperRefreshStep(1)) },
                footerText: (toCreateFormData?.selectedPayer?.PayerDetailId) ? `${toCreateFormData?.selectedPayer?.LastName} (${toCreateFormData.selectedPayer.IdType}: ${toCreateFormData?.selectedPayer?.IdNumber}) is selected` : ""
            }, {
                title: "Select recipient",
                stepBodyComponent: <SelectRecipient />,
                backButtonText: "Back",
                prevCb: () => { dispatch(setStepperRefreshStep(0)) },
                submitButtonText: "Next",
                submitButtonDisabled: toCreateFormData?.selectedRecipient?.RecipentDetailId ? false : true,
                submitButtonDisabledInfoCb: () => {
                    dispatch(addNotifications({ heading: "Recipient cannot be empty", message: "To continue, please select a recipient" }))
                },
                submitCb: () => { dispatch(setStepperRefreshStep(2)) },
            }, {
                title: "Basic information",
                stepBodyComponent: <BasicInformation />,
                backButtonText: "Back",
                prevCb: () => { dispatch(setStepperRefreshStep(1)) },
                submitButtonText: "Next",
                submitButtonDisabled: false,
                submitButtonDisabledInfoCb: () => { },
                submitCb: () => FormEventHandlers.handleNextBtnClick(FORM_STEP.BASIC, tempFormFieldsList, isIRSViewOn, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), () => dispatch(addNotifications({ heading: "There are some errors in the fields.", message: "To continue, please resolve these errors" }))),
            }, {
                title: "Federal information",
                stepBodyComponent: <FederalInformation />,
                backButtonText: "Back",
                prevCb: () => { },
                submitButtonText: "Next",
                submitButtonDisabled: false,
                submitButtonDisabledInfoCb: () => { },
                submitCb: () => FormEventHandlers.handleNextBtnClick(FORM_STEP.FEDERAL, tempFormFieldsList, isIRSViewOn, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), () => dispatch(addNotifications({ heading: "There are some errors in the fields.", message: "To continue, please resolve these errors" }))),
            }, {
                title: "State information",
                stepBodyComponent: <StateInformation />,
                backButtonText: "Back",
                prevCb: () => { },
                submitButtonText: "Next",
                submitButtonDisabled: false,
                submitButtonDisabledInfoCb: () => { },
                submitCb: () => FormEventHandlers.handleNextBtnClick(FORM_STEP.STATE, tempFormFieldsList, isIRSViewOn, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), () => dispatch(addNotifications({ heading: "There are some errors in the fields.", message: "To continue, please resolve these errors" }))),
            },{
                title: "Other information",
                stepBodyComponent: <OtherInformation />,
                backButtonText: "Back",
                prevCb: () => { },
                submitButtonText: "Next",
                submitCb: () => handleFormSubmit(),
            },{
                title: "Optional information",
                stepBodyComponent: <OptionalInformation />,
                backButtonText: "Back",
                submitButtonDisabled: (loadingState.state === CREATE_FORMS_LOADING_STATES.SAVING_FORM_LOADING) ? true : false,
                submitButtonDisabledInfoCb: () => { },
                prevCb: () => { },
                submitButtonText: "Save",
                submitCb: () => handleFormSubmit(),
            }
        ];

        const filteredFormSteps = formsPreLoadedData?.ShowRecipientStep
            ? formSteps
            : formSteps.filter(step => step.title !== "Select recipient");

        const tempFilteredCreateFormSteps = filteredFormSteps.filter((step, index) => {
            if (index === 0 || index === 1) {
                return true;
            }

            const category = step.title.split(" ")[0].toUpperCase();
            return categoryCounts[category] > 0;
        });

        const lastStepIndex = tempFilteredCreateFormSteps.length - 1;
        if (lastStepIndex >= 0) {
            const lastStep = tempFilteredCreateFormSteps[lastStepIndex];
            const lastStepCategory = lastStep.title.split(" ")[0].toUpperCase();
            lastStep.submitCb = () => handleFormSubmit(lastStepCategory);
            lastStep.submitButtonText = "Save";
        }

        setCreateFormSteps(tempFilteredCreateFormSteps);
    }, [toCreateFormData, tempFormFieldsList, isIRSViewOn]);

    const handleReset = () => {
        dispatch(setTempFormFieldsList(formFieldsList.data));
    }

    useEffect(() => {
        handleReset();
        const tempCategoryCount = {};
        for (const obj of formFieldsList.data) {
            const category = obj.Category;
            if (category) {
                if (tempCategoryCount.hasOwnProperty(category)) {
                    tempCategoryCount[category]++;
                } else {
                    tempCategoryCount[category] = 1;
                }
            }
        }
        setCategoryCounts(tempCategoryCount);

    }, [formFieldsList.data]);

    useEffect(() => {
        if (saveSingleFormSuccessData !== null) {
            navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.CREATENEW}/${FORM_SECTION_ROUTES.SUCCESS}?${queryParams.get("metaData") ? "metaData=" + queryParams.get("metaData") : ""}`);
        }
    }, [saveSingleFormSuccessData]);

    useEffect(() => {
        const page = queryParams.get('page')
        FormEventHandlers.updateOnFormSelectAndYearSelect(toCreateFormData, formsPreLoadedData, true, (requestData) => dispatch(getFormData({ page: page, ...requestData })), (availableYears) => dispatch(updateFormsPreLoadedData(availableYears))) 
    }, [toCreateFormData.selectedForm, toCreateFormData.selectedYear]);

    useEffect(() => {
        if(reloadFormsPreLoadedData){
            const page = queryParams.get('page')
            FormEventHandlers.updateOnFormSelectAndYearSelect(toCreateFormData, formsPreLoadedData, false, (requestData) => dispatch(getFormData({page: page, ...requestData})));
        }
        dispatch(setReloadFormsPreLoadedData(false));
    }, [reloadFormsPreLoadedData]);

    useEffect(() => {
        dispatch(getPayerList({ formName: toCreateFormData?.selectedForm?.FormId, year: toCreateFormData.selectedYear }));
    }, [toCreateFormData?.selectedForm?.FormId, toCreateFormData.selectedYear]);

    useEffect(() => {
        FormEventHandlers.updateTempFormFieldsListOnPayerSelect(tempFormFieldsList, toCreateFormData, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), true);
    }, [toCreateFormData.selectedPayer]);

    useEffect(() => {
        FormEventHandlers.handleRecipientSelect(tempFormFieldsList, toCreateFormData, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), true, initSelectedRecipientRenderDone);
        if(!initSelectedRecipientRenderDone /* && toCreateFormData?.selectedRecipient */){
            setInitSelectedRecipientRenderDone(true);
        }
    }, [toCreateFormData.selectedRecipient]);

    useEffect(() => {
        FormEventHandlers.updateOnPayerSelectAndFormSelect(toCreateFormData, (requestData) => dispatch(getRecipientList(requestData)), formsPreLoadedData, (data) => dispatch(setToCreateFormData(data)), false, initSelectedPayerRenderDone, false, () => {});
        if(!initSelectedPayerRenderDone && toCreateFormData?.selectedPayer) {
            setInitSelectedPayerRenderDone(true);
        }
    }, [toCreateFormData.selectedPayer]);

    useEffect(() => {
        FormEventHandlers.updateOnPayerSelectAndFormSelect(toCreateFormData, (requestData) => dispatch(getRecipientList(requestData)), formsPreLoadedData, (data) => dispatch(setToCreateFormData(data)), true, false, false, () => {});
    }, [toCreateFormData.selectedForm])

    useEffect(() => {
        FormEventHandlers.updateDependentFieldsArr(tempFormFieldsList, (reverseDependencyMap) => dispatch(setOnDependentFields(reverseDependencyMap)));
        if(toCreateFormData?.isFormEditMode && formDataFromRecordId){
            const payerObjectFromReturnedData = {};
            if(formDataFromRecordId.hasOwnProperty(IMPORTANT_FIELD_NAMES.PAYER_ID) && formDataFromRecordId[IMPORTANT_FIELD_NAMES.PAYER_ID] != 0){
                for (const key of Object.keys(formDataFromRecordId)) {
                    
                    const payerKeys = Forms.getPayerKeys();
                    const mappingKey = payerKeys[key];
                    if (mappingKey) {
                        payerObjectFromReturnedData[mappingKey] = formDataFromRecordId[key];
                    }
                }
    
                const recipientObjectFromReturnedData = {};
                for (const key of Object.keys(formDataFromRecordId)) {
                    const recipientKeys = Forms.getRecipientKeys();
                    const mappingKey = recipientKeys[key];
                    if (mappingKey) {
                        recipientObjectFromReturnedData[mappingKey] = formDataFromRecordId[key];
                    }
                }
                let tempToCreateFormData = {
                    ...toCreateFormData,
                    isFormEditMode: null,
                };
                if(Object.keys(payerObjectFromReturnedData).length > 0){
                    tempToCreateFormData = {
                        ...tempToCreateFormData,
                        selectedPayer: {
                            ...payerObjectFromReturnedData,
                        },
                    }
                }
    
                if(Object.keys(recipientObjectFromReturnedData).length > 0){
                    tempToCreateFormData = {
                        ...tempToCreateFormData,
                        selectedRecipient: {
                            ...recipientObjectFromReturnedData,
                        },
                    }
                }
                dispatch(setToCreateFormData({...tempToCreateFormData}));
                if(formDataFromRecordId[IMPORTANT_FIELD_NAMES.PAYEE_ID]){
                    dispatch(getRecipient(formDataFromRecordId[IMPORTANT_FIELD_NAMES.PAYEE_ID]));
                }
            }
        }
    }, [tempFormFieldsList]);

    useEffect(() => {
        if(shouldLoadNextFormInSeries){
            const page = queryParams.get('page')
            FormEventHandlers.updateOnFormSelectAndYearSelect(toCreateFormData, formsPreLoadedData, true, (requestData) => dispatch(getFormData({ page: page, ...requestData })));
            dispatch(setShouldLoadNextFormInSeries(null));
        }
    }, [shouldLoadNextFormInSeries]);

    const handleFormSubmit = (currentStep) => {
        const validationResult = FormEventHandlers.handleNextBtnClick(currentStep, tempFormFieldsList, isIRSViewOn, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), () => dispatch(addNotifications({ heading: "There are some errors in the fields.", message: "To continue, please resolve these errors" })));
        if (validationResult) {
            let finalFormObject = tempFormFieldsList.reduce((obj, item) => {
                obj[item.Name] = item.inputValue || null;
                return obj;
            }, {});
            finalFormObject = {
                ...finalFormObject,
                FormName: toCreateFormData?.selectedForm?.FormId,
                PayerID: toCreateFormData?.selectedPayer?.PayerDetailId,
            }
            if(toCreateFormData?.FormRecordId){
                finalFormObject = {
                    ...finalFormObject,
                    FormRecordId: toCreateFormData?.FormRecordId,
                }
            }
            dispatch(saveForm({
                formName: toCreateFormData.selectedForm.FormId,
                formData: { ...finalFormObject },
                toCreateFormData: toCreateFormData,
                formsInSeriesHistory: formsInSeriesHistory,
            }));
        }
    }

    return <>
        {   
            (isIRSViewAvailable && isIRSViewOn) ?
                <IrsFormView loadingState={loadingState} recipientListLoadingState={recipientListLoadingState} tempFormFieldsList={tempFormFieldsList} toCreateFormData={toCreateFormData} onDependentFields={onDependentFields} formsPreLoadedData={formsPreLoadedData} isIRSViewOn={isIRSViewOn} userInteractionPopupWResponseObj={userInteractionPopupWResponseObj} isStepperViewAvailable={isStepperViewAvailable} formsInSeriesHistory={formsInSeriesHistory} 
                    helpIconProps={{
                        onClickCb: (helpText) => {
                            dispatch(setShowHelpPopup(true));
                            dispatch(setHelpTextObj(helpText));
                        }
                    }} 
                />
                :
                <div style={styles.createFormContainer}>
                    <div style={styles.bodyContainer}>
                        <div style={styles.headerRow}>
                            <div style={styles.selectedFormInfo}>
                                <Heading type={HEADING.H1}>
                                    {toCreateFormData?.FormRecordId ? "Edit" : "Create"} Form {toCreateFormData.selectedForm.FormLabel}
                                </Heading>
                                <Heading type={HEADING.H3} customStyle={styles.formSubId} >
                                    OMB No. {toCreateFormData.selectedForm.OMBNo}
                                </Heading>
                            </div>
                            <div style={styles.previewOptionDiv}>
                                <span style={styles.previewFormText}>Would you like to preview form?</span>
                                <span style={styles.irsViewSwitch}>
                                    <Switch isOn={isIRSViewOn} name={"IRSSwitchOn"} switchUniqueId={"irs-switch"} onColor={Theme.SECONDARY} handleToggleCb={() => dispatch(setIsIRSViewOn(true))} customSwitchLabelStyle={createFormStyles.irsSwitchLabelCustomStyle} customSwitchButtonStyle={createFormStyles.irsSwitchButtonCustomStyle} />
                                </span>
                                <span style={styles.irsViewText}>Switch to IRS form view</span>
                            </div>
                        </div>
                        <div style={styles.stepperRow}>
                            <Loadable currentState={loadingState.state} loadingStates={[CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING]} messageMap={CREATE_FORM_STATES_MESSAGE_MAP} isNewLoadable={true}>
                                <StepperNavigation steps={createFormSteps} progressBarContainerStyle={styles.progressBar} showTopRowButtons={true} refreshStep={stepperRefreshStep} applyMaxHeightToBodyContainer={"55vh"} />
                            </Loadable>
                        </div>
                    </div>
                </div>
        }
        {
            (initialInteractionPopupWObj?.type) ? <RenderInteractionElement interactionObj={initialInteractionPopupWObj} userInteractionPopupWResponseObj={initialInteractionPopupWObj} /> : ""
        }
        {
            <Popup title={"Help"} onCloseCb={() => {dispatch(setShowHelpPopup(false)); dispatch(setHelpTextObj({}))}} showClose={true} isPopupOpen={showHelpPopup} customPopupSyles={styles.helpTextPopupStypes} customPopupHeaderStyles={styles.helpTextPopupHeaderStyles} childrenStyles={styles.helpTextChildrenStyles}>
                {
                    helpTextObj?.Value ? <iframe
                        key={helpTextObj?.Target ?? helpTextObj?.Value}
                        src={`${helpTextObj?.Value}${helpTextObj?.Target ?? ''}`}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        allowFullScreen
                    />
                    : 
                    <div>Facing some error. Please try again.</div>
                }
                
            </Popup>
        }
    </>
}